import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface Me {
  id: string;
  email: string;
  findingsEmail: string | null;
  name: string;
  role: "OWNER" | "ADMIN";
  smsCreditCents: number;
  emailVerifiedAt: string | null;
  phoneE164: string | null;
  street: string;
  zip: string;
  city: string;
  country: string;
}

interface MeResponse {
  authenticated: boolean;
  user?: Me;
}

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api<MeResponse>("/api/me"),
    staleTime: 30_000,
  });
}

interface AuthCtx {
  me: Me | null;
  loading: boolean;
}
const AuthContext = createContext<AuthCtx>({ me: null, loading: true });

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const q = useMe();
  return (
    <AuthContext.Provider value={{ me: q.data?.user ?? null, loading: q.isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
